import React from 'react';
import PropTypes from 'prop-types';
import { useStore } from 'react-redux';
import {
  getNotification,
  hideNotification,
} from '@americanexpress/banking-common';
import { ToastNotification } from '@americanexpress/banking-common/components';

const BankingRootWrapper = ({ children }) => {
  const { dispatch, getState } = useStore();
  const notification = getNotification(getState());

  const handleCloseNotification = () => {
    dispatch(hideNotification());
  };

  return (
    <div className="fs-unmask">
      {children}
      <ToastNotification
        id="globalNotificationMessage"
        show={notification.isVisible}
        message={notification.message}
        onClose={handleCloseNotification}
      />
    </div>
  );
};

BankingRootWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BankingRootWrapper;
